// extracted by mini-css-extract-plugin
module.exports = {"column":"ErrorBoundary-module__column___1le_L"};